import Moment from 'moment'
import {
  OfferReservationResponseItem,
  TopMenuGroupResponse
} from '@/types/service-response'
import BusinessTimeBlockCollection from "@/model/business/BusinessTimeBlockCollection";
import i18n from "@/i18n";
import ReservedOffer from "@/model/ReservedOffer";

export default class MenuReservationItem {

  private constructor (
    readonly acceptanceStatus:  any,
    readonly boarderNote: string | null,
    readonly boarder: any,
    readonly date: Date,
    readonly status: string,
    readonly reservationId: number,
    readonly topMenuGroup: TopMenuGroupResponse,
    readonly reservedOfferCollection: any[],
    readonly reservedOffers: ReservedOffer[],
    readonly timeBlock: BusinessTimeBlockCollection,
    readonly business: any
  ) {}


  get isMenuOfferedByDay (): boolean {

    let isOffered = true

    return isOffered
  }

  get dayName (): string {
    const date = Moment(this.date);
    date.locale(i18n.locale)
    return date.format("dddd")
  }

  get formatedDate (): string {
    const date = Moment(this.date);
    return date.format("D.M.Y")
  }

  get formatedDbDate (): string {
    const date = Moment(this.date);
    return date.format("Y-MM-DD")
  }

  static createFromResponse (responseData: OfferReservationResponseItem): MenuReservationItem {
    return new MenuReservationItem(
        responseData.acceptanceStatus,
      responseData.boarderNote,
      responseData.boarder,
      Moment(responseData.date).toDate(),
      responseData.status.name,
      responseData.id,
      responseData.topMenuGroup,
      responseData.reservedOfferCollection,
      ReservedOffer.createFromResponseList(responseData.reservedOffers),
      BusinessTimeBlockCollection.createFromResponse(responseData.timeBlock),
      responseData.business,

    )
  }
}
